import React from "react";
import Protfolio from "./Projects/Portfolio";

export default function App() {
  return (
    <div>
      <Protfolio />
    </div>
  );
}
